import React, { createContext, useState, useContext, ReactNode } from "react";
import { Editor } from "grapesjs";

interface HeaderEditorContextType {
  editor: Editor | null;
  setEditor: React.Dispatch<React.SetStateAction<Editor | null>>;
}

const HeaderEditorContext = createContext<HeaderEditorContextType | undefined>(
  undefined
);

interface HeaderEditorProviderProps {
  children: ReactNode;
}

export const HeaderEditorProvider: React.FC<HeaderEditorProviderProps> = ({
  children,
}) => {
  const [editor, setEditor] = useState<Editor | null>(null);

  editor?.on("canvas:drop", (dataTransfer, component) => {
    // only allow to drop one element in header sections
    const components = editor.DomComponents;
    const wrapper = components.getWrapper();
    wrapper.get("components").reset();
    // Add the new component to the wrapper
    if (component) {
      wrapper?.append(component);
    }
  });

  return (
    <HeaderEditorContext.Provider value={{ editor, setEditor }}>
      {children}
    </HeaderEditorContext.Provider>
  );
};

export const useHeaderEditor = (): HeaderEditorContextType => {
  const context = useContext(HeaderEditorContext);
  if (!context) {
    throw new Error(
      "useHeaderEditor must be used within a HeaderEditorProvider"
    );
  }
  return context;
};
